/**
 * This is the common config, imported / shared by Internet and Intranet search configs
 */

import { isBrowser } from 'browser-or-node';
import utils from './utils';

const getConfig = (options) => {
	let config = {
		debug: utils.getParamSwitch('cdcdebug'),
		isBrowser,
		env: 'prod',
		language: (isBrowser && document.documentElement && document.documentElement.lang) || 'en-us',
		pageSize: 10,

		// size limits for output
		limits: {
			title: 150,
			description: 230,
		},

		bestBets: {
			limit: 3,
			score: 100,
		},
	};

	config = utils.mergeDeep(config, options);

	// extend from window object to update config
	if (isBrowser) {
		if (window.CDC && CDC.Search && CDC.Search.config) {
			config = utils.mergeDeep(config, CDC.Search.config);
		}

		if (window) {
			if (window.CDC_SEARCH_CONFIG) {
				config = utils.mergeDeep(config, window.CDC_SEARCH_CONFIG);
			}
		}

		// browser support
		config = Object.assign(config, {
			browser: {
				hasDatePicker: (function () {
					if (!document) {
						return false;
					}
					var input = document.createElement('input');
					var value = 'a';
					input.setAttribute('type', 'date');
					input.setAttribute('value', value);
					return input.value !== value;
				})(),
			},
		});
	}

	// computed
	config.isEnglish = 'en-us' === config.language;
	config.isSpanish = 'es-us' === config.language;

	return config;
};

export default getConfig;
